export const colors = [
	'#E69F00',
	'#009E73',
	'#e81515',
	'#CC79A7',
	'#F0E442',
	'#000000',
	'#56B4E9',
	'#117733',
	'#999933',
	'#DDCC77',
	'#CC6677',
	'#882255',
	'#AA4499',
	'#3228da',
	'#44AA99',
	'#FF2E63',
	'#00C853',
	'#FFD600',
	'#FF6D00',
	'#7C4DFF',
	'#1DE9B6',
	'#C51162',
	'#8C564B',
	'#2CA02C',
	'#BCBD22',
	'#17BECF',
	'#9467BD',
	'#4D4D4D',
	'#B3B3B3',
	'#0072B2',
];
